<div class="container">
    <div class="card my-3" >
        <div class="card-header">
            <h3 class="card-title mb-0"><i class="fa-solid fa-qrcode me-2"></i><span class="manual">Manual</span>Radar
            </h3>
        </div>
        <div class="card-body">

             @if (error) {
                <div class="alert alert-danger mb-0" role="alert">
                    {{ error }}
                </div>
             }

            @if (element && element.type == 'folder') {
                <h4>Ordner</h4>

                <label>Name</label>
                <p>{{ element.name }}</p>

                @if (element.metadata.length > 0) {
                    <label>Metadaten</label>
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of element.metadata">
                            <td>
                                {{data.key}}
                            </td>
                            <td>
                                {{data.value}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }

                @if (!showFiles) {
                    <div class="mb-3" *ngIf="element.password">
                        <label>Passwort</label>
                        <input type="password" class="form-control" [(ngModel)]="password" (keyup.enter)="checkPassword()" required>
                    </div>

                    <div class="d-grid">
                        <button type="button" class="btn btn-lg btn-warning" (click)="checkPassword()"
                                [disabled]="element.password && !password">Anzeigen
                        </button>
                    </div>
                }

                <div class="alert alert-warning mt-3 mb-0" role="alert" *ngIf="showFiles && element.files.length == 0">
                    Dieser Ordner enthält keine Dokumente!
                </div>

                <table class="table table-sm mb-0" *ngIf="showFiles && element.files.length > 0">
                    <thead>
                        <tr>
                            <th>Dokumente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let file of element.files">
                            <td>
                                <a href="" (click)="$event.preventDefault(); selectElement(file.hash)">{{ file.name }}</a>
                            </td>
                        </tr>
                        <tr *ngFor="let link of element.links">
                            <td>
                                <a href="" (click)="$event.preventDefault(); selectElement(link.hash)">{{ link.name }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }

            @if (element && element.type == 'file') {
                <h4>Dokument</h4>

                <label>Name</label>
                <p>{{ element.name }}</p>

                <div class="row">
                    <div class="col">
                        <label>Erstellt</label>
                        <p>{{ element.created | date }}</p>
                    </div>
                    <div class="col">
                        <label>Größe</label>
                        <p>{{ element.size / 1024 / 1024 | fileSize }}</p>
                    </div>
                </div>

                <label>Beschreibung</label>
                <p>
                    {{ element.description }}
                    <span class="text-muted" *ngIf="!element.description">Nicht eingetragen</span>
                </p>

                @if (element.metadata.length > 0) {
                    <label>Metadaten</label>
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of element.metadata">
                            <td>
                                {{data.key}}
                            </td>
                            <td>
                                {{data.value}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }

                <div class="mb-3" *ngIf="element.password">
                    <label>Passwort</label>
                    <input type="password" class="form-control" [(ngModel)]="password" (keyup.enter)="download()" required>
                </div>

                <div class="d-grid">
                    <button type="button" class="btn btn-lg btn-warning" (click)="download()"
                            [disabled]="(element.password && !password) || downloading">Anzeigen
                    </button>
                    <button type="button" class="btn btn-lg btn-secondary mt-2"
                            *ngIf="parent"
                            (click)="selectParent()">Zurück
                    </button>
                </div>
            }

            @if (element && element.type == 'link') {
                <h4>Link</h4>

                <div class="row">
                    <div class="col">
                        <label>Name</label>
                        <p>{{ element.name }}</p>
                    </div>
                    <div class="col">
                        <label>Erstellt</label>
                        <p>{{ element.created | date }}</p>
                    </div>
                </div>

                <label>Beschreibung</label>
                <p>
                    {{ element.description }}
                    <span class="text-muted" *ngIf="!element.description">Nicht eingetragen</span>
                </p>

                @if (element.metadata.length > 0) {
                    <label>Metadaten</label>
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th>Schlüssel</th>
                            <th>Wert</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let data of element.metadata">
                            <td>
                                {{data.key}}
                            </td>
                            <td>
                                {{data.value}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                }

                <div class="mb-3" *ngIf="element.password">
                    <label>Passwort</label>
                    <input type="password" class="form-control" [(ngModel)]="password" (keyup.enter)="download()" required>
                </div>

                <div class="d-grid">
                    <button type="button" class="btn btn-lg btn-warning" (click)="openLink()"
                            [disabled]="(element.password && !password) || downloading">Öffnen
                    </button>
                    <button type="button" class="btn btn-lg btn-secondary mt-2"
                            *ngIf="parent"
                            (click)="selectParent()">Zurück
                    </button>
                </div>
            }
        </div>
    </div>
</div>
